<app-dialog [dialogWithInput]="dialog">
    <div class="button-bar">
        <app-button *ngIf="transcriptionInProgress" [tooltip]="dialog.input.stopRecordingTooltip" iconName="player-stop-filled" (clickEvent)="stopRecording()"></app-button>
    </div>
    <div class="row">
        <app-form-field [size]="12">
            <app-input-textarea [rows]="15" parentFormControlName="text" [parentFormGroup]="formGroup"></app-input-textarea>
        </app-form-field>
    </div>
    <app-button dialog-actions fill="solid" label="Enregistrer" (clickEvent)="stopRecording()"></app-button>
</app-dialog>
